import type { Theme } from '@mui/material/styles';

export function resolveCanvasFontFamily(
  fontFamily: Theme['typography']['fontFamily']
): string {
  if (Array.isArray(fontFamily)) {
    return fontFamily.join(', ');
  }

  return fontFamily ?? 'sans-serif';
}
